import React from 'react';
import { Box, CircularProgress } from '@mui/material';

export const FullScreenLoader = () => (
  <Box justifyContent="center" alignItems="center" height="100vh" width="100vw" display="flex">
    <CircularProgress aria-label="loading" />
  </Box>
);
